import moment from "moment";

export class Util {
	static CurrentRole: string = "";
	static isNullOrEmpty(val: any) {
		return typeof val === "undefined" || val === null || val === "null" || val.toString().trim() === "";
	}

	static Formatter(val: any, typeCode: string) {
		switch (typeCode) {
			case "D":
				if (this.isNullOrEmpty(val)) return null;

				return moment(val).format("MM/DD/YYYY");
			case "DT":
				if (this.isNullOrEmpty(val)) return null;

				return moment(val).format("MM/DD/YYYY hh:mm A");
			case "L":
				if (val) return "Yes";
				return "No";
			case "C":
				if (this.isNullOrEmpty(val)) return null;

				return "$" + Number(val).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
		}
	}

	static ParseDate(val: any) {
		if (this.isNullOrEmpty(val)) return null;

		const f = this.Formatter(val, "DT");
		return new Date(f as string);
	}

	/** Display-only: trim trailing .pdf (any case). */
	static stripPdfExtension(name: string | null | undefined) {
		if (this.isNullOrEmpty(name)) return "";
		const s = String(name).trim();
		return s.toLowerCase().endsWith(".pdf") ? s.slice(0, -4) : s;
	}
	static ticketTypes: Array<TicketType> = [
		{ ticket_type_id: "2DF67000-F308-4D81-B247-182C8CB08098", description: "Violation" },
		{ ticket_type_id: "C4F9E5F9-1FFC-413A-88BB-202BCC95CB55", description: "Call Back" },
		{ ticket_type_id: "9D13704F-808B-4267-A35F-245C7CB26D8D", description: "Sale" },
		{ ticket_type_id: "1DB19C7D-F075-4BBC-A763-7A045E11AF16", description: "Maintenance" },
		{ ticket_type_id: "DE11396C-340B-418E-B62D-8B0E1072248D", description: "Repair" },
		{ ticket_type_id: "CD874196-C3E0-40E5-B0A2-938546298756", description: "Nuisance" },
		{ ticket_type_id: "A9FA81E3-2A24-4F23-805F-EC943C58DBB8", description: "Open Order" },
	];
}

export interface TicketType {
	ticket_type_id: string;
	description: string;
}
